angular.module('project', ['core', 'property'])
    .constant('ProjectConst', {
        eventUpdate: 'project.updated',
        role: 'ROLE_PROJECT',
        roleFileWrite: 'ROLE_PROJECT_FILE_WRITE',
        roleWrite: 'ROLE_PROJECT_WRITE',
        roleStagingRead: 'ROLE_PROJECT_STAGING_READ',
        roleStagingWrite: 'ROLE_PROJECT_STAGING_WRITE',
    })
    .factory('Project', function ($resource) {
        return $resource('/crm/api/project/:id/:subresource', {id: "@id", subresource: "@subresource"}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/project/autocomplete'},
            salesTeamAutocomplete: {method: 'GET', isArray: true, url: '/crm/api/project/autocomplete/sales-team'},
            buildings: {method: 'GET', params: {subresource: "buildings"}, isArray: true},
            properties: {method: 'GET', params: {subresource: "properties"}, isArray: true},
            attributes: {method: 'GET', params: {subresource: "attributes"}, isArray: true},
            getStaging: {method: 'GET', url: '/crm/api/project/:id/staging'},
            getStagingItems: {method: 'GET', url: '/crm/api/project/:id/staging/items', isArray: true},
            saveStaging: {method: 'PUT', url: '/crm/api/project/:id/staging'},
            deleteStaging: {method: 'DELETE', url: '/crm/api/project/:id/staging'},
            assetGroups: {method: 'GET', params: {subresource: "asset-groups"}, isArray: true},
        });
    })
    .service('ProjectService', function ($state, $rootScope, Project, modals, ProjectConst, Principal, FilesSimpleUploadService) {
        this.add = () => {
            let entity = {
                id: null,
                state: 'PLANNED',
                members: [],
                buildings: [],
                attributes: []
            }
            return editModal(entity)
        }
        this.edit = id => {
            Project.get({id: id}, entity => editModal(entity))
        }
        this.show = id => {
            return Project.get({id: id}, entity => modals.open('app/project/show-modal.html', 'ProjectShowController', entity, {size: 'lg'}, "$ctrl"))
        }
        this.remove = (item) => {
            return modals.confirmDelete(item.name, () => Project.delete({id: item.id}, () => $rootScope.$broadcast(ProjectConst.eventUpdate)).$promise)
        }
        this.canReadStaging = (item) => {
            return item.id != null && Principal.hasAnyAuthority([ProjectConst.roleStagingRead])
        }
        this.canWriteStaging = (item) => {
            return item.id != null && Principal.hasAnyAuthority([ProjectConst.roleStagingWrite])
        }
        this.uploadDocument = (id) => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.openCustom({url: "/crm/api/file-association-project/" + id + "/upload", formData: {id: id}})
                .then(result => {
                    if (!angular.isArray(result) || result.length !== 1) {
                        toastr.error("Nie udało się przesłać pliku")
                        return
                    }
                    let classification = result[0];
                    modals.open('app/project/classification-modal.html', 'ProjectUploadClassificationController', classification, {size: 'md'}, "$ctrl")
                })
        }

        // this.uploadDocument = () => {
        //     FilesSimpleUploadService.openCustom({url: "/crm/api/file-association-invoice/" + this.item.id + "/assignment", formData: {id: this.item.id}}).then(result => {
        //         if(!angular.isArray(result) || result.length !== 1){
        //             toastr.error("Nie udało się przesłać pliku")
        //             return
        //         }
        //         let file = result[0];
        //         this.item.substantiveDescription = this.item.substantiveDescription || {}
        //         this.item.substantiveDescription.assignment = {
        //             file: file,
        //             type: file.type,
        //             uuid: file.uuid
        //         }
        //         delete this.item.substantiveDescription.noAssignment
        //     })
        // }

        function editModal(entity) {
            return modals.open('app/project/edit-modal.html', 'ProjectDialogController', entity, {size: 'lg'}, "$ctrl")
        }
    })
    .component('projectList', {
        bindings: {
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/project/list.html',
        controller($scope, $state, ProjectService, ProjectConst, Principal) {
            this.reset = () => this.filters = {}
            this.ProjectService = ProjectService
            this.canReadPropertyPriceTransparency = Principal.hasAnyAuthority(['ROLE_PROPERTY_PRICE_TRANSPARENCY'])

            $scope.$on(ProjectConst.eventUpdate, () => $state.reload())
        }
    })

    .controller('ProjectDialogController', function ($scope, data, $uibModalInstance, $rootScope, toastr, Project, Property, PropertyService, ProjectConst, Principal) {
        this.item = data;
        this.PropertyService = PropertyService;
        this.canReadPropertyPriceTransparency = Principal.hasAnyAuthority(['ROLE_PROPERTY_PRICE_TRANSPARENCY']);

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise;
            if (this.item.id) {
                promise = Project.update(this.item).$promise
            } else {
                promise = Project.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(ProjectConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .component('projectBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/project/_btn-options.html',
        controller: function (ProjectService, Principal, FilesSimpleUploadService, FilesLibrary, ProjectConst) {
            this.ProjectService = ProjectService
            this.FilesSimpleUploadService = FilesSimpleUploadService;
            this.FilesLibrary = FilesLibrary;

            this.$onChanges = () => {
                this.fileResourceName = "PROJECT";
                this.canUploadFiles = Principal.hasAnyAuthority([ProjectConst.roleFileWrite]);
            }
        }
    })
    .run((NavbarLeftMenu, ProjectConst) => {
        NavbarLeftMenu.add({
            authorities: ProjectConst.role,
            path: "/project",
            ico: "fa fa-fw fa-product-hunt",
            name: 'project.menu',
            order: 82
        })
    })
    .config(($stateProvider, ProjectConst) => {
        $stateProvider
            .state('projectList', {
                parent: 'app',
                url: '/project?{page:int}&{size:int}&sort&search',
                data: {
                    authorities: [ProjectConst.role]
                },
                views: {
                    'content@': 'projectList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Project, $stateParams) => Project.list(angular.copy($stateParams)).$promise
                }
            })
        $stateProvider.state('projectShowFull', {
            parent: 'app',
            url: '/project/{id}',
            data: {
                authorities: [ProjectConst.role]
            },
            views: {
                'content@': 'projectShow'
            },
            resolve: {
                item: (Project, $stateParams) => Project.get({id: $stateParams.id}).$promise
            }
        })
    })
